import MItemLabel from "./MItemLabel.vue";
export default MItemLabel;
export type { MItemLabelProps } from "./MItemLabel.props";
